var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "video-detail-page" } },
    [
      _c("div", { staticClass: "page-header" }, [
        _c(
          "div",
          { staticClass: "header-left" },
          [
            _c(
              "a-button",
              {
                staticClass: "back-btn",
                attrs: { type: "link" },
                on: { click: _vm.goBack },
              },
              [
                _c("span", { staticClass: "material-icons" }, [
                  _vm._v("arrow_back"),
                ]),
              ]
            ),
            _vm._v(" "),
            _vm.channel
              ? _c("div", { staticClass: "header-info" }, [
                  _c("span", { staticClass: "channel-badge" }, [
                    _c("span", { staticClass: "material-icons youtube-icon" }, [
                      _vm._v("smart_display"),
                    ]),
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.channel.name) +
                        "\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "separator" }, [_vm._v("/")]),
                  _vm._v(" "),
                  _vm.video
                    ? _c("span", { staticClass: "video-badge" }, [
                        _vm._v(_vm._s(_vm._f("truncate")(_vm.video.title, 50))),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "header-actions" },
          [
            _c(
              "a-button",
              {
                attrs: { type: "primary", size: "small", loading: _vm.syncing },
                on: { click: _vm.syncComments },
              },
              [
                _c("span", { staticClass: "material-icons btn-icon" }, [
                  _vm._v("sync"),
                ]),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("youtubeChannel.sync")) +
                    "\n            "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.video && !_vm.loading
        ? _c("div", { staticClass: "page-content" }, [
            _c("div", { staticClass: "content-layout" }, [
              _c("div", { staticClass: "video-section" }, [
                _c("div", { staticClass: "video-player" }, [
                  _c("iframe", {
                    attrs: {
                      src:
                        "https://www.youtube.com/embed/" +
                        _vm.video.videoId +
                        "?rel=0&modestbranding=1",
                      frameborder: "0",
                      allow:
                        "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                      allowfullscreen: "",
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "video-details" }, [
                  _c("h1", { staticClass: "video-title" }, [
                    _vm._v(_vm._s(_vm.video.title)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "video-stats-row" }, [
                    _c("div", { staticClass: "stat-chip" }, [
                      _c("span", { staticClass: "material-icons" }, [
                        _vm._v("visibility"),
                      ]),
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.formatNumber(_vm.video.viewCount)) +
                          " " +
                          _vm._s(_vm.$t("youtubeChannel.views")) +
                          "\n                        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "stat-chip" }, [
                      _c("span", { staticClass: "material-icons" }, [
                        _vm._v("thumb_up"),
                      ]),
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.formatNumber(_vm.video.likeCount)) +
                          "\n                        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "stat-chip" }, [
                      _c("span", { staticClass: "material-icons" }, [
                        _vm._v("chat_bubble"),
                      ]),
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.formatNumber(_vm.video.commentCount)) +
                          "\n                        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "stat-chip" }, [
                      _c("span", { staticClass: "material-icons" }, [
                        _vm._v("schedule"),
                      ]),
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.formatDuration(_vm.video.duration)) +
                          "\n                        "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "video-meta-row" }, [
                    _c("span", { staticClass: "meta-item" }, [
                      _c("span", { staticClass: "material-icons" }, [
                        _vm._v("event"),
                      ]),
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.formatDate(_vm.video.publishedAt)) +
                          "\n                        "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.video.description
                    ? _c(
                        "div",
                        { staticClass: "video-description" },
                        [
                          _c(
                            "p",
                            { class: { expanded: _vm.descriptionExpanded } },
                            [_vm._v(_vm._s(_vm.video.description))]
                          ),
                          _vm._v(" "),
                          _vm.video.description.length > 200
                            ? _c(
                                "a-button",
                                {
                                  attrs: { type: "link", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      _vm.descriptionExpanded =
                                        !_vm.descriptionExpanded
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.descriptionExpanded
                                          ? _vm.$t("youtubeChannel.showLess")
                                          : _vm.$t("youtubeChannel.showMore")
                                      ) +
                                      "\n                        "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.video.tags && _vm.video.tags.length > 0
                    ? _c(
                        "div",
                        { staticClass: "video-tags" },
                        [
                          _vm._l(_vm.video.tags.slice(0, 8), function (tag) {
                            return _c("a-tag", { key: tag }, [
                              _vm._v(_vm._s(tag)),
                            ])
                          }),
                          _vm._v(" "),
                          _vm.video.tags.length > 8
                            ? _c("a-tag", [
                                _vm._v("+" + _vm._s(_vm.video.tags.length - 8)),
                              ])
                            : _vm._e(),
                        ],
                        2
                      )
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "comments-section" }, [
                _c("div", { staticClass: "comments-header" }, [
                  _c("h2", { staticClass: "comments-title" }, [
                    _c("span", { staticClass: "material-icons" }, [
                      _vm._v("forum"),
                    ]),
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("youtubeChannel.comments")) +
                        "\n                        "
                    ),
                    _c("span", { staticClass: "count" }, [
                      _vm._v(_vm._s(_vm.total)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "comments-filters" },
                    [
                      _c(
                        "a-select",
                        {
                          staticStyle: { width: "120px" },
                          attrs: { size: "small" },
                          model: {
                            value: _vm.filters.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.filters, "status", $$v)
                            },
                            expression: "filters.status",
                          },
                        },
                        [
                          _c("a-select-option", { attrs: { value: "" } }, [
                            _vm._v(_vm._s(_vm.$t("youtubeChannel.all"))),
                          ]),
                          _vm._v(" "),
                          _c("a-select-option", { attrs: { value: "new" } }, [
                            _vm._v(_vm._s(_vm.$t("youtubeChannel.new"))),
                          ]),
                          _vm._v(" "),
                          _c(
                            "a-select-option",
                            { attrs: { value: "replied" } },
                            [_vm._v(_vm._s(_vm.$t("youtubeChannel.replied")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "a-select-option",
                            { attrs: { value: "resolved" } },
                            [_vm._v(_vm._s(_vm.$t("youtubeChannel.resolved")))]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("a-input-search", {
                        staticStyle: { width: "160px" },
                        attrs: {
                          placeholder: _vm.$t("youtubeChannel.searchComments"),
                          size: "small",
                        },
                        on: { search: _vm.fetchComments },
                        model: {
                          value: _vm.filters.search,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "search", $$v)
                          },
                          expression: "filters.search",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                !_vm.commentsLoading
                  ? _c(
                      "div",
                      { staticClass: "comments-list" },
                      [
                        _vm._l(_vm.comments, function (comment) {
                          return _c(
                            "div",
                            { key: comment._id, staticClass: "comment-item" },
                            [
                              comment.authorProfileImageUrl
                                ? _c("img", {
                                    staticClass: "comment-avatar",
                                    attrs: {
                                      src: comment.authorProfileImageUrl,
                                    },
                                  })
                                : _c(
                                    "span",
                                    {
                                      staticClass:
                                        "material-icons avatar-fallback",
                                    },
                                    [_vm._v("account_circle")]
                                  ),
                              _vm._v(" "),
                              _c("div", { staticClass: "comment-body" }, [
                                _c("div", { staticClass: "comment-top" }, [
                                  _c("span", { staticClass: "author" }, [
                                    _vm._v(_vm._s(comment.authorDisplayName)),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "date" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatDate(comment.publishedAt)
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "status-badge",
                                      class: comment.status,
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getStatusLabel(comment.status)
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  comment.moderationStatus
                                    ? _c(
                                        "span",
                                        {
                                          staticClass: "moderation-badge",
                                          class: comment.moderationStatus,
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                _vm.getModerationLabel(
                                                  comment.moderationStatus
                                                )
                                              ) +
                                              "\n                                "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass: "comment-text",
                                  domProps: { innerHTML: _vm._s(comment.text) },
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "comment-bottom" }, [
                                  _c("span", { staticClass: "likes" }, [
                                    _c(
                                      "span",
                                      { staticClass: "material-icons" },
                                      [_vm._v("thumb_up")]
                                    ),
                                    _vm._v(
                                      " " + _vm._s(comment.likeCount || 0)
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "actions" },
                                    [
                                      _c(
                                        "a-button",
                                        {
                                          attrs: {
                                            size: "small",
                                            type: "link",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.openReplyModal(comment)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "material-icons" },
                                            [_vm._v("reply")]
                                          ),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("youtubeChannel.reply")
                                              ) +
                                              "\n                                    "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a-dropdown",
                                        {
                                          attrs: { trigger: ["click"] },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "overlay",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "a-menu",
                                                      [
                                                        _c(
                                                          "a-sub-menu",
                                                          {
                                                            key: "status",
                                                            attrs: {
                                                              title: _vm.$t(
                                                                "youtubeChannel.status"
                                                              ),
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "a-menu-item",
                                                              {
                                                                key: "new",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.updateCommentStatus(
                                                                        comment,
                                                                        "new"
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                                                        " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "youtubeChannel.new"
                                                                      )
                                                                    ) +
                                                                    "\n                                                    "
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "a-menu-item",
                                                              {
                                                                key: "replied",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.updateCommentStatus(
                                                                        comment,
                                                                        "replied"
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                                                        " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "youtubeChannel.replied"
                                                                      )
                                                                    ) +
                                                                    "\n                                                    "
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "a-menu-item",
                                                              {
                                                                key: "resolved",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.updateCommentStatus(
                                                                        comment,
                                                                        "resolved"
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                                                        " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "youtubeChannel.resolved"
                                                                      )
                                                                    ) +
                                                                    "\n                                                    "
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "a-sub-menu",
                                                          {
                                                            key: "mod",
                                                            attrs: {
                                                              title: _vm.$t(
                                                                "youtubeChannel.moderation"
                                                              ),
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "a-menu-item",
                                                              {
                                                                key: "published",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.handleModeration(
                                                                        comment,
                                                                        "published"
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c("a-icon", {
                                                                  staticStyle: {
                                                                    color:
                                                                      "#52c41a",
                                                                  },
                                                                  attrs: {
                                                                    type: "check-circle",
                                                                  },
                                                                }),
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "youtubeChannel.publish"
                                                                      )
                                                                    ) +
                                                                    "\n                                                    "
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "a-menu-item",
                                                              {
                                                                key: "heldForReview",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.handleModeration(
                                                                        comment,
                                                                        "heldForReview"
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c("a-icon", {
                                                                  staticStyle: {
                                                                    color:
                                                                      "#faad14",
                                                                  },
                                                                  attrs: {
                                                                    type: "clock-circle",
                                                                  },
                                                                }),
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "youtubeChannel.holdForReview"
                                                                      )
                                                                    ) +
                                                                    "\n                                                    "
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "a-menu-item",
                                                              {
                                                                key: "rejected",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.handleModeration(
                                                                        comment,
                                                                        "rejected"
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c("a-icon", {
                                                                  staticStyle: {
                                                                    color:
                                                                      "#ff4d4f",
                                                                  },
                                                                  attrs: {
                                                                    type: "close-circle",
                                                                  },
                                                                }),
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "youtubeChannel.reject"
                                                                      )
                                                                    ) +
                                                                    "\n                                                    "
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        },
                                        [
                                          _c(
                                            "a-button",
                                            {
                                              attrs: {
                                                size: "small",
                                                type: "link",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "material-icons",
                                                },
                                                [_vm._v("tune")]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                              ]),
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _vm.comments.length === 0
                          ? _c("div", { staticClass: "empty-comments" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v("chat_bubble_outline"),
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("youtubeChannel.noCommentsFound")
                                  )
                                ),
                              ]),
                            ])
                          : _vm._e(),
                      ],
                      2
                    )
                  : _c(
                      "div",
                      { staticClass: "comments-loading" },
                      [_c("a-spin")],
                      1
                    ),
                _vm._v(" "),
                _vm.total > _vm.pagination.limit
                  ? _c(
                      "div",
                      { staticClass: "comments-pagination" },
                      [
                        _c("a-pagination", {
                          attrs: {
                            current: _vm.pagination.page,
                            total: _vm.total,
                            "page-size": _vm.pagination.limit,
                            size: "small",
                            "show-size-changer": "",
                          },
                          on: {
                            change: _vm.onPageChange,
                            showSizeChange: _vm.onPageSizeChange,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ]),
          ])
        : _vm.loading
        ? _c(
            "div",
            { staticClass: "page-loading" },
            [
              _c("a-spin", { attrs: { size: "large" } }),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.$t("youtubeChannel.loadingVideo")))]),
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "page-error" },
            [
              _c("span", { staticClass: "material-icons" }, [
                _vm._v("error_outline"),
              ]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.$t("youtubeChannel.videoNotFound")))]),
              _vm._v(" "),
              _c(
                "a-button",
                { attrs: { type: "primary" }, on: { click: _vm.goBack } },
                [_vm._v(_vm._s(_vm.$t("youtubeChannel.goBack")))]
              ),
            ],
            1
          ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            title: _vm.$t("youtubeChannel.replyToComment"),
            "confirm-loading": _vm.replyModal.loading,
            width: "500px",
          },
          on: { ok: _vm.submitReply },
          model: {
            value: _vm.replyModal.visible,
            callback: function ($$v) {
              _vm.$set(_vm.replyModal, "visible", $$v)
            },
            expression: "replyModal.visible",
          },
        },
        [
          _vm.replyModal.comment
            ? _c("div", { staticClass: "reply-original" }, [
                _vm.replyModal.comment.authorProfileImageUrl
                  ? _c("img", {
                      attrs: {
                        src: _vm.replyModal.comment.authorProfileImageUrl,
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("div", [
                  _c("strong", [
                    _vm._v(_vm._s(_vm.replyModal.comment.authorDisplayName)),
                  ]),
                  _vm._v(" "),
                  _c("p", {
                    domProps: {
                      innerHTML: _vm._s(_vm.replyModal.comment.text),
                    },
                  }),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("a-textarea", {
            attrs: {
              placeholder: _vm.$t("youtubeChannel.writeYourReply"),
              rows: 4,
              maxLength: 10000,
            },
            model: {
              value: _vm.replyModal.text,
              callback: function ($$v) {
                _vm.$set(_vm.replyModal, "text", $$v)
              },
              expression: "replyModal.text",
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "char-count" }, [
            _vm._v(_vm._s(_vm.replyModal.text.length) + " / 10000"),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }